import { useSidebar } from "ui";

import { SidebarCommunicationActions } from "src/components/SidebarCommunicationActions";
import { SidebarGroups } from "src/components/SidebarSidebarGroups";
import { useSidebarTab } from "src/components/sidebarTabContext";
import {
  type SidebarConfig,
  type SidebarTabConfig,
  type SidebarTabsConfig,
} from "src/staticData";

import { SidebarChatTab } from "../layout/SidebarChatTab";

interface SidebarTabbedBodyProps {
  config: SidebarConfig;
}

function getSidebarTabByValue(
  tabs: SidebarTabsConfig | undefined,
  value: string,
): SidebarTabConfig | null {
  if (!tabs) {
    return null;
  }

  return (
    tabs.items.find((item) => {
      return item.value === value;
    }) ?? null
  );
}
export function SidebarTabbedBody(props: SidebarTabbedBodyProps) {
  const sidebar = useSidebar();
  const ctx = useSidebarTab();
  const activeTab = getSidebarTabByValue(props.config.tabs, ctx.tab);

  const isAiTab = activeTab?.content?.type === "aiChats";

  if (isAiTab && sidebar.state === "expanded") {
    return <SidebarChatTab />;
  }

  return (
    <>
      {isAiTab || props.config.showCommunicationActions === false ? null : (
        <SidebarCommunicationActions />
      )}
      <SidebarGroups groups={props.config.groups} />
    </>
  );
}
